import swiperUtil from '../utils/swiper-util';

export default (node) => {
  /**
   * Data + elements
   */
  const pagination = node.querySelector('[data-pagination]');
  const pausePlayButtons = node.querySelectorAll('[data-play-pause-button]');
  const volumeButtons = node.querySelectorAll('[data-volume-button]');

  const animationSpeed = node.dataset.animationSpeed;
  let swiper = null;

  /**
   * Functions
   */
  function checkAnimationTimer() {
    pagination.style.setProperty('--pagination-timer', `${animationSpeed}ms`);
  }

  function checkIfLastSlide() {
    if (swiper.isEnd) {
      return swiper.slideTo(0);
    }
    swiper.slideNext();
  }

  function handlePausePlayButtonClick(target, playIcon, pauseIcon) {
    const videoWrapper = target.closest('button').previousElementSibling;
    const videos = videoWrapper.querySelectorAll('video');

    if (pagination.classList.contains('paused')) {
      pagination.classList.remove('paused');
      pauseIcon.classList.remove('hidden');
      playIcon.classList.add('hidden');
      videos.forEach((video) => {
        if (window.innerWidth < 800 && video.dataset.mobileVideo) {
          video.play();
          return;
        }
        if (video.dataset.desktopVideo) {
          video.play();
          return;
        }
      });
      return;
    }

    pagination.classList.add('paused');
    pauseIcon.classList.add('hidden');
    playIcon.classList.remove('hidden');
    videos.forEach((video) => {
      if (window.innerWidth < 800 && video.dataset.mobileVideo) {
        video.pause();
        return;
      }
      if (video.dataset.desktopVideo) {
        video.pause();
        return;
      }
    });
  }

  function handleVolumeButtonClick(target, volumeOnIcon, volumeOffIcon) {
    const videoWrapper =
      target.closest('button').previousElementSibling.previousElementSibling;

    const videos = videoWrapper.querySelectorAll('video');

    if (pagination.classList.contains('unmuted')) {
      pagination.classList.remove('unmuted');
      volumeOffIcon.classList.remove('hidden');
      volumeOnIcon.classList.add('hidden');

      const isMobile = window.matchMedia('(max-width: 800px)').matches;
      videos.forEach((video) => {
        if (isMobile && video.dataset.mobileVideo) {
          video.muted = true;
          return;
        }
        if (!isMobile && video.dataset.desktopVideo) {
          video.muted = true;
          return;
        }
      });
      return;
    }

    pagination.classList.add('unmuted');
    volumeOffIcon.classList.add('hidden');
    volumeOnIcon.classList.remove('hidden');
    const isMobile = window.matchMedia('(max-width: 800px)').matches;

    videos.forEach((video) => {
      if (isMobile && video.dataset.mobileVideo) {
        video.muted = false;
        return;
      }
      if (!isMobile && video.dataset.desktopVideo) {
        video.muted = false;
        return;
      }
    });
  }

  /**
   * Init
   */
  const init = () => {
    swiper = swiperUtil(node, {
      // autoHeight: true,
      pagination: {
        el: pagination,
        clickable: true,
      },
    });
    checkAnimationTimer();

    pausePlayButtons.forEach((button) => {
      const playIcon = button.querySelector('[data-play-icon]');
      const pauseIcon = button.querySelector('[data-pause-icon]');
      button.addEventListener('click', ({ target }) =>
        handlePausePlayButtonClick(target, playIcon, pauseIcon)
      );
    });

    volumeButtons.forEach((button) => {
      const volumeOnIcon = button.querySelector('[data-volume-on]');
      const volumeOffIcon = button.querySelector('[data-volume-off]');
      button.addEventListener('click', ({ target }) =>
        handleVolumeButtonClick(target, volumeOnIcon, volumeOffIcon)
      );
    });

    swiper.on('slideChange', checkAnimationTimer);
    pagination.addEventListener('animationend', checkIfLastSlide);
  };

  init();
};
